<template>
    <v-container fluid class="pa-0">
        <v-card color="indigo lighten-3" class="pa-3 mb-5">
            <v-row class="px-2">
                <v-col cols="10" sm="6" md="4" lg="3" xl="2">
                    <v-menu ref="menuCalendar" v-model="dispCalender" :close-on-content-click="false" nudge-top="25" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field solo dense v-model="targetDateText" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
                        </template>
                        <v-date-picker range v-model="dPicker" locale="jp" :max="maxDate" :day-format="(date) => new Date(date).getDate()" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dispCalender = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="commitCalendar(dPicker)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="5" sm="3" md="3" lg="2" xl="2">
                    <v-select solo dense :items="goodLevelMinOptions" v-model="goodLevelMinSelected" hide-details label="評価"></v-select>
                </v-col>
                <v-col cols="5" sm="3" md="3" lg="2" xl="2">
                    <v-select solo dense :items="goodLevelMaxOptions" v-model="goodLevelMaxSelected" hide-details></v-select>
                </v-col>
            </v-row>
        </v-card>
        <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="(rec, idx) in dialogImages" :key="'IMG' + idx" v-show="levelCheck(rec.good_level)">
                <v-card class="ma-2 pa-3">
                    <h3>分析日時 : --- AI未分析 ---</h3>
                    <h3>獣種 : --- AI未分析 ---</h3>
                    <h3>頭数 : --- AI未分析 ---</h3>
                    <h3>誘引位置 : --- AI未分析 ---</h3>
                    <h3>緯度 : {{ rec.gps_latitude }}</h3>
                    <h3>経度 : {{ rec.gps_longitude }}</h3>
                    <img :src="rec.jpgBlob" class="mt-5" width="100%" />
                    <h5>受信日時：{{ $moment(rec.received_at).format("YYYY-MM-DD HH:mm:ss") }}</h5>
                    <div>
                        <v-btn text :disabled="goodBtnDisabled" color="success" @click="goodLevelUpdate(rec.id, 1)"><v-icon>mdi-thumb-up</v-icon></v-btn>
                        <v-btn text :disabled="goodBtnDisabled" color="error" @click="goodLevelUpdate(rec.id, -1)"><v-icon>mdi-thumb-down</v-icon></v-btn>
                        <span class="ml-5">評価 : {{ rec.good_level }}</span>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <infinite-loading ref="infiniteLoading" @infinite="infiniteHandler">
            <h1 class="ma-5 pa-5" slot="spinner">Loading...</h1>
            <h1 class="ma-5 pa-5" slot="no-more">--- End ---</h1>
            <h1 class="ma-5 pa-5" slot="no-results">--- No Results ---</h1>
        </infinite-loading>
    </v-container>
</template>

<script>
import JWT from "jsonwebtoken";
import InfiniteLoading from "vue-infinite-loading";
export default {
    //#########################################################################################
    name: "CompShotLog",
    //#########################################################################################
    components: {
        InfiniteLoading,
    },
    //#########################################################################################
    props: ["device_id"],
    //#########################################################################################
    data() {
        return {
            dialogImages: [],
            infiniteOffset: 0,
            pageLimit: 6,
            //-------------------------------
            dispCalender: false,
            dPicker: [this.$moment().add(0, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
            targetDate: [this.$moment().add(0, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
            maxDate: this.$moment().format("YYYY-MM-DD"),
            //-------------------------------
            goodBtnDisabled: false,
            goodLevelMinSelected: 0,
            goodLevelMinOptions: [
                { value: -5, text: "評価 -5以上" },
                { value: -4, text: "評価 -4以上" },
                { value: -3, text: "評価 -3以上" },
                { value: -2, text: "評価 -2以上" },
                { value: -1, text: "評価 -1以上" },
                { value: 0, text: "評価 0以上" },
                { value: 1, text: "評価 1以上" },
                { value: 2, text: "評価 2以上" },
                { value: 3, text: "評価 3以上" },
                { value: 4, text: "評価 4以上" },
                { value: 5, text: "評価 5以上" },
            ],
            goodLevelMaxSelected: 5,
            goodLevelMaxOptions: [
                { value: -5, text: "評価 -5以下" },
                { value: -4, text: "評価 -4以下" },
                { value: -3, text: "評価 -3以下" },
                { value: -2, text: "評価 -2以下" },
                { value: -1, text: "評価 -1以下" },
                { value: 0, text: "評価 0以下" },
                { value: 1, text: "評価 1以下" },
                { value: 2, text: "評価 2以下" },
                { value: 3, text: "評価 3以下" },
                { value: 4, text: "評価 4以下" },
                { value: 5, text: "評価 5以下" },
            ],
            //-------------------------------
        };
    },
    //#########################################################################################
    created: async function () {},
    //#########################################################################################
    mounted: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return true;
        }
        this.myInfo = JWT.decode(this.jwt);
        if (this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return true;
        }
    },
    //#########################################################################################
    watch: {
        device_id: function (newID, oldID) {
            if (newID != oldID) self.console.log({ newID, oldID });
            this.dialogImages = [];
            this.infiniteOffset = 0;
            if (this.$refs.infiniteLoading) {
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        },
        targetDate: function (newDate, oldDate) {
            if (newDate != oldDate) self.console.log({ newDate, oldDate });
            this.dialogImages = [];
            this.infiniteOffset = 0;
            if (this.$refs.infiniteLoading) {
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        },
    },
    //#########################################################################################
    computed: {
        targetDateText() {
            if (this.targetDate.length > 1) {
                return this.targetDate.join(" ~ ");
            } else {
                return this.targetDate;
            }
        },
    },
    //#########################################################################################
    methods: {
        //====================================================
        // 無限スクロール
        //====================================================
        infiniteHandler($state) {
            //self.console.log($state);
            //----------------------------------
            const startRec = this.infiniteOffset * this.pageLimit;
            const device_id = this.device_id;
            //----------------------------------
            let sdate = "";
            let edate = "";
            if (this.targetDate.length == 2) {
                sdate = this.targetDate[0];
                edate = this.targetDate[1];
            } else {
                sdate = this.targetDate[0];
                edate = this.targetDate[0];
            }
            edate = this.$moment(edate).add(1, "days").format("YYYY-MM-DD");
            //----------------------------------
            this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                params: {
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                    device_id: device_id,
                    "_order[id]": "desc",
                    _limit: startRec + "," + this.pageLimit,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(async (response) => {
                await new Promise((r) => setTimeout(r, 1000));
                //--------------------------
                let tmpJson = response.data.json;
                for (let i in tmpJson) {
                    tmpJson[i]["jpgBlob"] = null;
                    let jpg_file = tmpJson[i].jpg_file_path;
                    if (jpg_file) this.getImageBlob(device_id, jpg_file, tmpJson[i]);
                    //-------------------------------------
                }
                //--------------------------
                this.dialogImages = this.dialogImages.concat(tmpJson);
                if (response.data.length < this.pageLimit) {
                    $state.complete();
                } else {
                    $state.loaded();
                    this.infiniteOffset += 1;
                }
                //self.console.log("Infinite Load =", this.infiniteOffset);
            });
            //--------------------------------------------
        },
        //====================================================
        async getImageBlob(device_id, path, imgObj) {
            await this.axios({
                responseType: "blob",
                method: "GET",
                url: "/web/api/image/",
                params: {
                    device_id: device_id,
                    path: path,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                imgObj.jpgBlob = window.URL.createObjectURL(response.data);
            });
        },
        //====================================================
        async commitCalendar(date) {
            //----------------------------------
            let sdate = date[0];
            let edate = date[0];
            if (date.length == 2) {
                sdate = date[0];
                edate = date[1];
            }
            const diffDays = this.$moment(edate).diff(sdate, "days");
            self.console.log({ diffDays });
            if (diffDays >= 31) {
                alert("日付の範囲は31日以内にして下さい。");
                return false;
            }
            //----------------------------------
            this.targetDate = date.sort();
            if (this.targetDate.length > 1 && this.targetDate[0] == this.targetDate[1]) {
                this.targetDate.pop();
            }
            this.dispCalender = false;
            //----------------------------------
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            // const promiseDevices = this.axiosGetDevices();
            // const promiseShotLogs = this.axiosGetShotLogs();
            // await promiseDevices;
            // await promiseShotLogs;
            // this.dispMarker();
            // this.dispHeatmap();
            // this.dispMesh();
            this.isLoading = false;
            //--------------------------------
        },
        //====================================================
        async goodLevelUpdate(pk, val) {
            for (let idx in this.dialogImages) {
                if (this.dialogImages[idx]["id"] == pk) {
                    if (val < 0 && this.dialogImages[idx]["good_level"] <= -5) return;
                    if (val > 0 && this.dialogImages[idx]["good_level"] >= 5) return;
                }
            }
            //------------------------------------------
            this.goodBtnDisabled = true;
            for (let idx in this.dialogImages) {
                if (this.dialogImages[idx]["id"] == pk) {
                    this.dialogImages[idx]["good_level"] += val;
                    let good_level = this.dialogImages[idx]["good_level"];
                    //-----------------------------------
                    this.axios({
                        method: "PUT",
                        url: "/web/api/shot_logs/" + pk,
                        data: {
                            good_level: good_level,
                        },
                        headers: { Authorization: "Bearer " + this.jwt },
                        timeout: 30000,
                    });
                    //-----------------------------------
                }
            }
            await new Promise((r) => setTimeout(r, 500));
            this.goodBtnDisabled = false;
        },
        //====================================================
        levelCheck(good_level) {
            let ret = true;
            if (good_level < this.goodLevelMinSelected) ret = false;
            if (good_level > this.goodLevelMaxSelected) ret = false;
            return ret;
        },
        //====================================================
    },
    //#########################################################################################
};
</script>
